import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import './PopupStatus.css';

// Popup baseado em sucesso e fracasso de ações;
// Feito a partir do Popup do devextreme;
// Recebe Status e statusToggle;
// Status é o objeto retornado após uma requisição;
// setStatus é a função que zera o status, fazendo o popup desaparecer.



const Aviso = ({ message, confirmAction, cancelAction, statusToggle }) => {

    const buttonRef = useRef();

    useEffect(() => {
        if(confirmAction){
            buttonRef.current.focus();
            const func = e => {
                document.activeElement.blur();
                e.preventDefault();
                e.stopPropagation();
                if(e.key === 'Enter'){
                    handleClick(confirmAction);
                }
                else if(e.key === 'Escape') {
                    handleClick(cancelAction);
                }
            };
    
            setTimeout(() => {
                document.addEventListener('keydown', func);
            }, 50);
            
            return () => document.removeEventListener('keydown', func);
        }
    }, [confirmAction]);

    const handleClick = useCallback((action) => {
        action();
        statusToggle();
    }, []);

    return(
        <div className={`modalAviso statusAviso bg-light p-2 ${confirmAction ? '' : 'timer'}`.trim()} onAnimationEnd={() => !confirmAction && statusToggle()} >
            <i className='bi bi-exclamation-triangle text-warning statusIcon' ></i>
            <p className='mb-1 mx-3'>
                {message}
            </p>
            { confirmAction &&
                <>
                    <button className='confirmButton me-2' onClick={ () => handleClick(confirmAction)} ref={buttonRef}>Sim</button>
                    <button className='cancelButton me-2' onClick={ () => handleClick(cancelAction) }>Não</button>
                </>
            }
        </div>
    );
};

const PopupStatus = ({ status, statusToggle }) => {

    const Sucesso = useCallback(({ message }) => {
        return(
            <div className='modalStatus statusSucesso bg-light p-2' onAnimationEnd={() => statusToggle()} >
                <i className='bi bi-check-circle text-success statusIcon' ></i>
                <p className='mb-1 mx-3'>
                    {message}
                </p>
            </div>
        );
    }, []);
    const Erro = useCallback(({ message }) => {
        return(
            <div className='modalStatus statusErro bg-light p-2' onAnimationEnd={() => statusToggle()} >
                <i className='bi bi-x-circle text-danger statusIcon' onClick={() => statusToggle()} ></i>
                <p className='mb-1 mx-3'>
                    {message}
                </p>
            </div>
        );
    }, []);

    if(typeof status === 'string'){
        return <Erro message={status} />;
    }
    else if(status?.alert){
        return <Aviso message={status.alert} confirmAction={status.confirmAction} cancelAction={status.cancelAction} statusToggle={statusToggle} />;
    }
    else if(status?.data?.message || status?.data?.retorno){
        return <Sucesso message={status.data.message || status.data.retorno} />;
    }
    else if(status?.response?.data?.message){
        return <Erro message={status.response.data.message} />;
    }
    else if(status?.message){
        console.log(status);
        return <Erro message='Sem conexão com o servidor. Tente novamente mais tarde!' />;
    }
    else {
        return <></>;
    }
};

PopupStatus.propTypes = {
    status: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    statusToggle: PropTypes.func.isRequired
};

PopupStatus.defaultProps = {
    status: undefined,
    statusToggle: () => {}
};

export default PopupStatus;
